import React from 'react';
import { connect } from 'react-redux';
import MercurXBackButton from '../../components/MercurXBackButton/MercurXBackButton';
import MercurXNftDetailInputs from '../../components/MercurXNftDetailInputs/MercurXNftDetailInputs';
import './CreateNewNft.scss';

function CreateNewNft() {
  return (
    <div>
      <MercurXBackButton buttonText="Back to NFT list" />
      <div className="text-fs-head-sm">Create new NFT</div>
      <MercurXNftDetailInputs isEdit={false} />
    </div>
  );
}

export default connect(null, null)(CreateNewNft);
